import { Component, ChangeDetectionStrategy, input, signal } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslocoPipe } from '@jsverse/transloco';
import { translation } from '@cue/translations';
import { QRCodeModule } from '@progress/kendo-angular-barcodes';
import { LocalizedString } from '@cue/api';
import { LocalizedStringPipe } from '@cue/utilities';
import { cueQrScan, IconComponent } from '@cue/ui/icons';

@Component({
  selector: 'assist-qr-code-viewer',
  templateUrl: './qr-code-viewer.component.html',
  styleUrls: ['./qr-code-viewer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslocoPipe, ReactiveFormsModule, QRCodeModule, LocalizedStringPipe, IconComponent],
})
export class QrCodeViewerComponent {
  protected translation = translation;
  currentUriData = input<string>();
  qrCodeCustomTextNoLocalization = input<string>();
  hideText = input<boolean>(false);
  qrCodeCustomText = input<LocalizedString>();

  protected ICONS = {
    cueQrScan,
  };

  protected get hasOverlayIcon(): boolean {
    return (
      window.innerWidth < window.innerHeight || (window.innerWidth < 1000 && window.innerWidth > window.innerHeight)
    );
  }
}
